import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MyOverlayRef } from '../overlay/myoverlay-ref';

@Component({
  selector: 'app-payroll-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
  imports: [FormsModule],
})
export class ConfirmModalComponent implements OnInit {
  private overlayRef = inject<MyOverlayRef>(MyOverlayRef);

  inputConfirmText: any;
  wrong_confirm_text = false;
  action: string;
  type: string;
  color: string;
  description: string;
  confirmText: string;
  title: string;

  constructor() {
    const data = this.overlayRef.data;

    this.type = data?.type;
    this.action = data?.action;
    this.description = data?.description || '';
    this.confirmText = data?.confirmText;
    this.title = data?.title;
  }

  ngOnInit() {
    if (this.action === 'delete') {
      this.color = 'warn';
    } else {
      this.color = 'primary';
    }
  }

  onCloseDialog(): void {
    this.overlayRef.close();
  }

  onConfirm(): void {
    this.overlayRef.close(true);
  }

  confirmInput() {
    if (this.inputConfirmText) {
      if (this.inputConfirmText.toLowerCase() === this.confirmText) {
        this.wrong_confirm_text = false;
      } else {
        this.wrong_confirm_text = true;
      }
    }
  }

  resetWrongInput() {
    this.wrong_confirm_text = false;
  }

  confirmAction() {
    this.overlayRef.close('confirmed');
  }
}
